__turbopack_context__.v({
  "column": "CollectionsFeed-module__B5CzKW__column",
  "footer": "CollectionsFeed-module__B5CzKW__footer",
  "grid": "CollectionsFeed-module__B5CzKW__grid",
  "header": "CollectionsFeed-module__B5CzKW__header",
  "loading": "CollectionsFeed-module__B5CzKW__loading",
  "root": "CollectionsFeed-module__B5CzKW__root",
  "table": "CollectionsFeed-module__B5CzKW__table",
});
